const flinksErrors = {
  CONCURRENT_SESSION: 'Another session is in progress. Please try again later.',
  INVALID_LOGIN: 'The username or password provided is invalid',
  INVALID_USERNAME: 'The username or password provided is invalid',
  INVALID_PASSWORD: 'The username or password provided is invalid',
  INVALID_SECURITY_RESPONSE: 'The security challenge response provided was incorrect',
  QUESTION_NOT_FOUND: 'The security challenge did not have a stored response',
  RETRY_LATER: 'Unable to connect to financial institution. Please try again.',
  UNKNOWN_CHALLENGE_KEY: 'Missing response to security challenge',
  UNAUTHORIZED: 'Unable to authorize with the financial institution',
  DISABLED_LOGIN: 'This account has been deactivated by the financial institution',
  NEW_ACCOUNT: 'Unable to log into this account. Please complete your account setup with the financial institution.',
  SESSION_EXPIRED: 'The session with your financial institution timed out. Please try again.',
  SECURITYRESPONSES_INCOMPLETE: 'Missing response to security challenge',
};

export default (handlers) => (response) => {
  if (!response) return handlers.onUnrecognizedResponse;
  if (response.HttpStatusCode === 200) return handlers.onLoginSuccess;
  if (response.HttpStatusCode === 203) return handlers.onChallenge;
  if (response.HttpStatusCode === 401 && response.FlinksCode in flinksErrors) {
    return () => handlers.onError(flinksErrors[response.FlinksCode]);
  }
  if (response.HttpStatusCode === 401) {
    return () => handlers.onError(response.Message);
  }
  return handlers.onUnrecognizedResponse;
};
